export default "__VITE_ASSET__DB_YYfv$__"